import React, { ReactNode, useState } from 'react'
import { Sidebar } from './Sidebar'
import { Header } from './Header'
import { useAuth } from '@/hooks/useAuth'

interface DashboardLayoutProps {
  children: ReactNode
}

export const DashboardLayout: React.FC<DashboardLayoutProps> = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false)
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false)
  const { isImpersonating, user } = useAuth()

  return (
    <div className="min-h-screen bg-[var(--color-bg-secondary)]">
      {isImpersonating && user && (
        <div className="sticky top-0 z-[60] bg-[var(--color-info)] text-white text-sm text-center py-2 px-4 h-10">
          Session en tant que {user.firstname} {user.lastname} ({user.email}) — actualisez la page pour
          revenir à votre compte administrateur
        </div>
      )}
      <Sidebar
        isOpen={isSidebarOpen}
        isCollapsed={isSidebarCollapsed}
        onClose={() => setIsSidebarOpen(false)}
        onToggleCollapse={() => setIsSidebarCollapsed(!isSidebarCollapsed)}
      />
      <div className={`transition-all duration-300 ${isSidebarCollapsed ? 'lg:pl-20' : 'lg:pl-64'}`}>
        <Header
          onToggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)}
          onToggleSidebarCollapse={() => setIsSidebarCollapsed(!isSidebarCollapsed)}
        />
        <main className="p-6 sm:p-8 mx-auto">{children}</main>
      </div>
    </div>
  )
}
